import { useMemo } from 'react'
import { useGetServicetypes } from '@/api/generated/service-type/service-type'
import { normalizeServiceTypes } from '@/utils/normalizeServiceTypes'

/**
 * Shared service-types read.
 *
 * Replaces the management/member `getServiceTypes` thunks and the cross-slice
 * GET_SERVICE_TYPES(_MEMBER) reducer coupling: every consumer (management, member, visits,
 * availability, calendar, new-visit) now reads from one React Query cache instead of two
 * Redux slices kept in sync via shared action types. The list is server state that only
 * changes when service types are created/edited/deleted/reordered, after which the relevant
 * page remounts and React Query refetches (matching the old refetch-on-navigation behavior).
 *
 * Returns the raw list plus the normalized { entities, ids } shape the old
 * `normalizedServiceTypes` slice exposed.
 */
export const useServiceTypes = () => {
  const query = useGetServicetypes()
  const serviceTypes = useMemo(() => query.data ?? [], [query.data])
  const normalizedServiceTypes = useMemo(() => normalizeServiceTypes(serviceTypes), [serviceTypes])

  return { ...query, serviceTypes, normalizedServiceTypes }
}
